import {useEffect, useState} from 'react';
import {WindowSizeEnum} from "../interface/Basic/window";


interface useWindowResizeProps{
    currentSize : WindowSizeEnum,
    isDesktop : boolean,
    isMobile : boolean,
    isTablet: boolean,
    isDesktopOrTablet : boolean,
    isTabletOrMobile : boolean
}

export const useWindowResize = () : useWindowResizeProps => {

    const [currentSize, setCurrentSize ] = useState(WindowSizeEnum.Desktop)

    const handleResize = () => {
        if(window.innerWidth <= WindowSizeEnum.Mobile){
            setCurrentSize(WindowSizeEnum.Mobile)
        }else{
            if(window.innerWidth <= WindowSizeEnum.Tablet ){
                setCurrentSize(WindowSizeEnum.Tablet)
            }
        }
        if(window.innerWidth > WindowSizeEnum.Tablet){
            setCurrentSize(WindowSizeEnum.Desktop)
        }
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return {
        currentSize : currentSize,
        isDesktop : currentSize === WindowSizeEnum.Desktop,
        isMobile : currentSize === WindowSizeEnum.Mobile,
        isTablet : currentSize === WindowSizeEnum.Tablet,
        isDesktopOrTablet : ( currentSize === WindowSizeEnum.Desktop ||  currentSize === WindowSizeEnum.Tablet),
        isTabletOrMobile : ( currentSize === WindowSizeEnum.Tablet ||  currentSize === WindowSizeEnum.Mobile)
    }
}
